import { render, staticRenderFns } from "./SearchCryptoAddressesHeader.vue?vue&type=template&id=2da5fa4e&"
import script from "./SearchCryptoAddressesHeader.vue?vue&type=script&lang=js&"
export * from "./SearchCryptoAddressesHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchCryptoAddressesHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports